// extracted by mini-css-extract-plugin
export default {"font-renta":"CatalogModal_font-renta__ECUbn"};